import { Box, Button, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'

import Process from '../../../resources/images/process.png'
import { ProjectDetailComponent } from '../../common/detailComponent'
import { useNavigate, useParams } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SDG1 from '../../../resources/images/SDG1.png';
import SDG2 from '../../../resources/images/SDG2.png';
import SDG3 from '../../../resources/images/SDG5.png';
import SDG4 from '../../../resources/images/SDG8.png';
import SDG5 from '../../../resources/images/SDG13.png';
import SDG6 from '../../../resources/images/SDG14.png';
import SDG7 from '../../../resources/images/SDG15.png';
import { getProjectByName, getProjectsList } from '../../../utils/mergeData';
import { getAnalysisTypesForProject } from '../../../utils/mapLayerUtils';
// import DMapTile from './DMap/DMapTile';
import ProjectOverviewMap from './ProjectOverviewMap'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const ProjectDetail = () => {
    const { projectName } = useParams();
    const projectList = getProjectsList();
    const selectedProjectStr = localStorage.getItem('selectedProject');
    const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : projectList[0];
    
    // Find project by URL param first, then by name, then fallback
    const project = projectName 
        ? getProjectByName(projectName.replace(/-/g, ' ')) || selectedProject
        : selectedProject;

    const navigate = useNavigate();
    const handleBack = () => {
        navigate('/');
    }
    const images = project?.gallery?.filter((i: any) =>
        i.url.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i)
    );

    const videos = project?.gallery?.filter((i: any) =>
        i.url.match(/\.(mp4|wav|ogg|aac|mp3)$/i)
    );

    const galleryItems = [...(images || []) as any, ...(videos || []) as any]; // Combine images and videos

    const chunkArray = (array: any[], size: number) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };

    return (
        <Box>
            <Button className="back-btn" onClick={handleBack} startIcon={<ArrowBackIcon />}>Back</Button>
            <ProjectDetailComponent
                id={(project as any).display_project_id || project.project_id}
                title={project.project_name}
                subTitle={project.project_status}
                icon={Process}
                startDateTitle={"Credit Period Start"}
                startDate={project.project_start_date}
                endDateTitle={"Credit Period End"}
                endDate={project.project_end_date}
                detailTitle={project.project_developer || ''}
                details={project.project_description}
                projectType={project.project_type}
                numberOfSites={project.number_of_sites}
                sdg={[SDG1, SDG2, SDG3, SDG4, SDG5, SDG6, SDG7]}
                reductionUnit={project.emission_reduction_unit || ''}
                creditPeriod={project.crediting_period || ''}
                avgReduction={project.avg_annual_emission_reduction || ''}
                totalReduction={`${project.total_emission_reduction_over_crediting_period || ''} ${project.emission_reduction_unit || ''}`}
                totalArea={project.total_area || ''}
                sensorTypes={getAnalysisTypesForProject(project?.project_name)}
            >
                <Box>
                    <ProjectOverviewMap projectName={project?.project_name} />
                </Box>

                {/* <Box sx={{ m: 2 }}>
                    <div style={{ whiteSpace: "nowrap", padding: "10px" }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>Project Gallery</Typography>
                        <Grid container spacing={2} justifyContent="center">
            {galleryItems.map((item: any, index: number) => (
                <Grid size={{ xs:6,sm:4,md:3}}>
                    {item.url.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i) ? (
                        <img
                            src={item.url}
                            alt="Gallery Item"
                            style={{
                                width: "100%",
                                height: "150px",
                                objectFit: "cover",
                                borderRadius: "5px",
                            }}
                        />
                    ) : (
                        <video
                            controls
                            style={{
                                width: "100%",
                                height: "150px",
                                objectFit: "cover",
                                borderRadius: "5px",
                            }}
                        >
                            <source src={item.url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    )}
                </Grid>
            ))}
        </Grid>
                    </div>
                </Box> */}
                <Box sx={{ my: 2 }}>
                    <Typography sx={{ fontSize: '22px', fontWeight: 600, my: 2 }}>Project Gallery</Typography>
                    {galleryItems.length <= 4 ? (
                        <Grid container spacing={2}>
                            {galleryItems.map((item: any, index: number) => (
                                <Grid key={`grid-item-${index}`} size={{ xs: 12, sm: 6, md: galleryItems.length === 1 ? 12 : galleryItems.length === 2 ? 6 : 4 }}>
                                    {item.url.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i) ? (
                                        <img
                                            src={item.url}
                                            alt="Gallery Item"
                                            style={{
                                                width: "100%",
                                                height: "250px",
                                                objectFit: "cover",
                                                borderRadius: "10px",
                                            }}
                                        />
                                    ) : (
                                        <video
                                            controls
                                            style={{
                                                width: "100%",
                                                height: "250px",
                                                objectFit: "cover",
                                                borderRadius: "10px",
                                            }}
                                        >
                                            <source src={item.url} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                    ) : (
                        <Swiper
                            navigation={true}
                            modules={[Navigation]}
                            spaceBetween={10}
                            slidesPerView={4}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 5,
                                },
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                            }}
                        >
                            {chunkArray(galleryItems, 4).map((chunk, chunkIndex) => (
                                <SwiperSlide key={`chunk-${chunkIndex}`}>
                                    <Box display="flex" gap="10px" flexWrap="wrap" justifyContent="center">
                                        {chunk.map((item: any, index: number) => (
                                            <Box key={`item-${chunkIndex}-${index}`} width="48%">
                                                {item.url.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i) ? (
                                                    <img
                                                        src={item.url}
                                                        alt="Gallery Item"
                                                        style={{
                                                            width: "100%",
                                                            height: "150px",
                                                            objectFit: "cover",
                                                            borderRadius: "5px",
                                                        }}
                                                    />
                                                ) : (
                                                    <video
                                                        controls
                                                        style={{
                                                            width: "100%",
                                                            height: "150px",
                                                            objectFit: "cover",
                                                            borderRadius: "5px",
                                                        }}
                                                    >
                                                        <source src={item.url} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                )}
                                            </Box>
                                        ))}
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}
                </Box>
            </ProjectDetailComponent>
            {/* ))} */}
        </Box>
    )
}

export default ProjectDetail